import { Modal, Button as Btn } from "antd";

import { useTranslation } from "contexts/TranslationContext";
import comingSoon from "assets/svg/ComingSoonOtherServices.png";
import "./OtherServices.css";

// "Coming Soon" dialog shown when a not-yet-available service card is clicked
// (from either the Home carousel or the View All page). Controlled via
// `open` / `onClose`.
const ComingSoonModal = ({ open, onClose }) => {
  const { translate } = useTranslation();

  return (
    <Modal
      className="comingSoonModal"
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={720}
      destroyOnClose
    >
      <div className="flex flex-col items-center text-center px-4 py-6">
        <img src={comingSoon} alt="Coming soon" className="w-full mb-6" />

        <h2 className="text-2xl md:text-3xl font-bold text-[#101010] mb-3">
          {translate("OTHER_SERVICES.COMING_SOON_TITLE")}
        </h2>

        <p className="text-[#5F5F5F] text-sm md:text-base max-w-md mb-8">
          {translate("OTHER_SERVICES.COMING_SOON_DESC")}
        </p>

        <Btn
          className="rounded-full bg-primary text-white font-semibold px-12 py-5 border border-primary hover:!border-primary hover:border-solid hover:!text-primary"
          onClick={onClose}
        >
          {translate("OTHER_SERVICES.CONTINUE")}
        </Btn>
      </div>
    </Modal>
  );
};

export default ComingSoonModal;
